
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Spinner as LoadingSpinner } from '@/components/spinners';
import { RequestForm, FinishMessage } from './components';
import { Request, Users } from './types';

@Component({
  components: {
    LoadingSpinner,
    RequestForm,
    FinishMessage,
  },
})
export default class EventRequestForm extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly users!: Users;

  @Prop({ type: Boolean, default: false })
  readonly isLoading!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isRequestExecuted!: boolean;

  @Prop({ type: Object })
  readonly message!: object;

  @Prop({ type: Object, default: null })
  readonly errors!: any;

  submitRequest(request: Request) {
    this.$emit('submitRequest', request);
  }

  cancelRequest() {
    this.$emit('cancelRequest');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/request/EventRequestForm.vue